import React, {useEffect, useRef} from 'react';
import * as Yup from "yup";
import {
  Button,
  FormikInput,
  PhoneInput,
  validateName,
  validateNativeRut,
  validateOptionalEmail
} from "presentation/common";

import {Form, Formik} from "formik";
import {MailIcon} from "presentation/common/components/style-guide/icons";
import {formatRut} from "presentation/common/helpers/validate/rut/rut";
import {UseProfile} from "./use-profile";

import styles from './profile.module.scss';

export const ProfilePage = () => {
  const {userInfo, onUpdate} = UseProfile();
  const ref = useRef();

  useEffect(() => {
    if (!userInfo?.profile) return;
    ref.current?.setFieldValue('phone', userInfo?.profile?.phone || userInfo?.phone ? '+' + (userInfo?.profile?.phone || userInfo?.phone) : '');
    ref.current?.setFieldValue('rut', formatRut(userInfo?.rut));
  }, [userInfo]);

  return (
    <Formik
      innerRef={ref}
      initialValues={{
        ...{
          email: '',
          name: '',
          fatherLastName: '',
          motherLastName: '',
          phone: '',
          rut: '',
          countryCode: 'CL'
        },
        ...(userInfo?.profile || {})
      }}
      validationSchema={
        Yup.object().shape({
          rut: validateNativeRut,
          email: validateOptionalEmail,
          name: validateName('nombre'),
          fatherLastName: validateName('apellido paterno'),
          motherLastName: Yup.string().matches(/^[A-Za-zÀ-ÿ ]*$/, 'El apellido materno no es válido.').max(100, "La cantidad máxima de caracteres es 100."),
          phone: Yup.lazy((value, context) => {
            return Yup.string().nullable().phone(context.parent.countryCode)
          })
        })}
      onSubmit={onUpdate}>
      {
        (formik) => {
          const {
            setFieldValue,
            setFieldTouched,
          } = formik;

          return (
            <Form className='p-6'>
              <span className="text-primary uppercase">Mi Perfil</span>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-4">
                <FormikInput
                  prefixIcon={(<MailIcon fill="#9FA6B2"/>)}
                  label="Correo Electrónico"
                  name='email'
                  disabled
                />

                <FormikInput
                  name='rut'
                  label="RUT"
                  required
                  setFormat={value => {
                    setFieldValue('rut', formatRut(value));
                    setTimeout(() => setFieldTouched('rut', true, false));
                  }}
                />

                <FormikInput
                  Component={PhoneInput}
                  country={'cl'}
                  name={`phone`}
                  label="Teléfono"
                  onChange={(v, phoneDetails) => {
                    setFieldValue(`phone`, v, true);
                    setFieldValue(`countryCode`, phoneDetails.countryCode.toUpperCase());
                    setTimeout(() => setFieldTouched(`phone`, true, false));
                  }}
                />

                <FormikInput
                  name={`name`}
                  label="Nombre"
                  required/>

                <FormikInput
                  name={`fatherLastName`}
                  label="Apellido Paterno"
                  required/>

                <FormikInput
                  name={`motherLastName`}
                  label="Apellido Materno"/>
              </div>

              <Button label="Guardar" className={styles.btn} type="submit"/>
            </Form>
          )
        }
      }
    </Formik>
  );
};
